module.exports = __webpack_public_path__ + "static/img/10_03.ed477266.png";